<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header -->
      <b-navbar class="p-0" toggleable="lg" :type="isDark ? 'dark' : 'light'" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand class="ml-4">
          <strong>Estoque</strong>
          <small> Material do Almoxarifado</small>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <c-switch type="text" class="px-1 p-0 md-0 mr-3" variant="primary-outline-alt" on="POSITIVOS" off="TODOS" :checked="true" v-model="positivos"/>
              
               <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarHtml()" title="Imprimir/HTML" v-b-tooltip.hover.bottom> 
                  <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarExcel()" title="Exportar Excel" v-b-tooltip.hover.bottom> 
                  <span style="font-size: 1.2rem" > <i  class="fa fa-file-excel-o"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarCsv()" title="Exportar CSV" v-b-tooltip.hover.bottom> 
                  <span style="font-size: 1.2rem" > <i  class="fa fa-file-text-o"></i></span>
              </b-button>

              <b-button class="px-2 ml-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop="imprimirPorGrupo()" title="Imprimir por Grupo" v-b-tooltip.hover.bottom>
                <span style="font-size: 1.0rem" ><i class="fa fa-print"></i> Por Grupo</span>
              </b-button>                   
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop="imprimirPorProduto()" title="Imprimir por Produto" v-b-tooltip.hover.bottom>
                <span style="font-size: 1.0rem" ><i class="fa fa-print"></i> Por Produto</span>
              </b-button>  

              <b-button class="ml-2" pill type="button"  variant="primary" @click.stop.prevent="pesquisar()">
                <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon> Atualizar
              </b-button>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <!-- Tabela -->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">
          <b-table 
            class="table table-sm mb-2"
            id="table-transition-example"
            ref="tbl"
            
            :dark="isDark"
            :items="itensFiltrados"
            :fields="colunas"
            :per-page="perPage"
            :current-page="currentPage"
            :sticky-header="stickyHeight"
            :tbody-tr-class="rowClassSelecionado"
            :head-variant="isDark ? 'dark' : 'light'"
            hover 
            small 
            bordered 
            show-empty
            empty-text="Informe o filtro para ver os registros "
            responsive 
            @row-clicked="selecionarRegistro"
            >
          
            <!-- Cabeçalho: ID -->
            <template #head(CODIGO)>
              <SetFilter
                label="ID"
                v-model="filtros.CODIGO"
                :options="opcoes.CODIGO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <!-- Cabeçalho: Situação -->
            <template #head(OP_SALDO)>
              <SetFilter
                label="Situação"
                v-model="filtros.OP_SALDO"
                :options="opcoes.OP_SALDO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <!-- Cabeçalho: Produto -->
            <template #head(DESCRICAO)>
              <SetFilter
                label="Produto"
                v-model="filtros.DESCRICAO"
                :options="opcoes.DESCRICAO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
             <template #empty>
              <div class="h-100 d-flex align-items-center justify-content-center">
                Nenhum registro encontrado
              </div>
            </template>

            <template #cell(OP_SALDO)="item">
              <b-badge pill :variant="colorirOP_SALDO(item.item.OP_SALDO)" >{{traduzirOP_SALDO(item.item.OP_SALDO)}} </b-badge>
            </template>

            <template #cell(actions)="item">
               <b-button type="button" @click.stop.prevent="abrirModalTrilha(item.item)" size="sm" variant="info" title="Trilha de Auditoria">
                <i class="fa fa-tasks"></i>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REQUISICAO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-requisicao" 
          id="modal-requisicao" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="2">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Cadastro">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="2">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-select 
                      v-model="requisicao.REQUISITANTE_ID" 
                      ref="comboID_UNIDADE_COMERCIAL"
                      :options="optionsREQUISITANTE_ID"  
                      :state="!!requisicao.REQUISITANTE_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-select 
                      v-model="requisicao.CENTRO_CUSTO_ID" 
                      ref="comboCENTRO_CUSTO_ID"
                      :options="optionsCENTRO_CUSTO_ID"  
                      :state="!!requisicao.CENTRO_CUSTO_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-select 
                      v-model="requisicao.DEPARTAMENTO_ID" 
                      ref="comboDEPARTAMENTO_ID"
                      :options="optionsDEPARTAMENTO_ID"  
                      :state="!!requisicao.DEPARTAMENTO_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
            </b-row>
            <b-row class=" mt-0 mb-1 text-right">
                <b-col sm="12">
                  <b-button 
                            variant="success" 
                            ref="btAdicionarItem"
                            @click.stop="abrirModalItemRequisicaoAdd"
                            v-b-popover.hover.left="'Incluir Movimentação'" > 
                        <i class="fa fa-plus"></i> Incluir Item 
                  </b-button>
                </b-col>
              
              </b-row>
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhuma compra"
                stacked="md"
                small
                @row-clicked="abrirModalItemRequisicaoEdit"
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalRequisicao.currentPage"
                :items="modalRequisicao.items" 
                :fields="modalRequisicao.fields">
                <template #cell(RAZAOSOCIAL)="row">
                  {{ row.item.RAZAOSOCIAL }} - {{ row.item.FORNECEDOR_ID }} 
                </template>
                <template #cell(actions)="item">
                  <b-button type="button" @click.stop.prevent="deleteItemRequisicao(item.item)" size="sm" variant="danger " >
                    <i class="fa fa-times"></i>
                  </b-button>
                </template>
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirOP_SALDO(item.item.STATUS_ATENDIMENTO)" >{{traduzirOP_SALDO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button v-if="requisicao.ID > 0"   variant="success" @click="requisitarRequisicao()">
            REQUISITAR
          </b-button>
          <b-button    variant="danger" @click="fecharModalRequisicao()">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>
    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITEM REQUISICAO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-requisicao-item" 
          id="modal-requisicao-item" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          @shown="focusModalRequisacaoItem()" 
          body-class="p-0"
          size="lg"
          headerClass= "p-2 border-bottom-0" 
          title="ITEM DA REQUISICAO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ITEM DA REQUISICAO 
              </div>
            </div>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <bens-pesquisa 
                                      @retornaId="item.PRODUTO_ID = $event"
                                      @retornaCusto="item.VL_UNITARIO = $event"
                                      :idInicial="item.PRODUTO_ID"
                                      :classe-required="!!item.PRODUTO_ID"
                                      id="edItemPRODUTO_ID"
                                      ref="edItemPRODUTO_ID"
                                      label="Produto"
                                      place="Informe o Produto"
                                      labelBotao="">
                    </bens-pesquisa>
                  </b-form-group>
                </b-col>
              </b-row>  
              <b-row> 
                <b-col sm="4">
                </b-col> 
                <b-col sm="4">
                  <b-form-fieldset label="Estoque Disponível">
                    <vue-autonumeric  v-model="estoque.quant" 
                                      :disabled="true"
                                      ref="edEstoqueQUANT"
                                      :options="{
                                          ...formatoQuantidade
                                      }"
                                      class="form-control text-right">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                
                <b-col sm="4">
                  <b-form-fieldset label="Unidades">
                    <vue-autonumeric  v-model="item.QUANT_REQUISITADO" 
                                      ref="edQUANT_REQUISITADO"
                                      :options="{
                                        ...formatoQuantidade,
                                        minimumValue: '0',
                                        maximumValue: Number(estoque.quant || 0.00)
                                      }" 
                                      
                                      :class="['form-control text-right',
                                                {'is-invalid' : !item.QUANT_REQUISITADO,
                                                  'is-valid': !!item.QUANT_REQUISITADO
                                                }
                                              ]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
          </b-card>
        <template #modal-footer="{ cancel }">
          <b-button v-if="modalRequisicaoItem.emAlteracao == false" variant="success" @click="postItemRequisicao()">
            Gravar
          </b-button>
          <b-button v-else variant="success" @click="editItemRequisicao()">
            Gravar Alterações
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ATENDIMENTO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-atendimento" 
          id="modal-atendimento" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="ATENDIMENTO DA REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ATENDIMENTO DA REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="3">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Requisitante">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Atendimento">
                  <b-form-input type="text" id="edUsuarioRequisitante" :disabled="true"  v-model="requisicao.USUARIO_ATENIMENTO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="3">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeRequisitante"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeCentroCusto"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeDepartamento"></b-form-input>
                </b-form-fieldset>
              </b-col>
            </b-row>
            
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhum Item"
                stacked="md"
                small
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalAtendimento.currentPage"
                :items="modalAtendimento.items" 
                :fields="modalAtendimento.fields">
                <template #cell(QUANT_ATENDIMENTO)="{ item }">
                  <b-input-group  >
                    <vue-autonumeric  v-model="item.QUANT_ATENDIMENTO" 
                                      class="form-control text-right" 
                                      :disabled="item.atendido == true"
                                      :options="{
                                        ...formatoQuantidade,
                                        minimumValue: '0',
                                        maximumValue: (item.QUANT_REQUISITADO || 0)
                                      }"  > 
                    </vue-autonumeric>
                    
                    <template #append>
                      <b-button type="button" v-if="permiteDeleteQuantAtendimento(item)" @click.stop.prevent="deleteQuantAtendimento(item)" size="sm" variant="danger " > <i class="fa fa-times"></i></b-button>
                      <b-button type="button" v-if="permitePostQuantAtendimento(item)" @click.stop.prevent="postQuantAtendimento(item)" size="sm" variant="success "> <i class="fa fa-check"></i></b-button>
                    </template>

                  </b-input-group>
                </template>
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirOP_SALDO(item.item.STATUS_ATENDIMENTO)" >{{traduzirOP_SALDO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="primary" @click.stop="finalizarAtendimento()">
            FINALIZAR
          </b-button>
          <b-button v-if="habilitaBotaoRejeitar == true" variant="outline-warning" @click.stop="rejeitarRequisicao()">
            REJEITAR
          </b-button>
          <b-button    variant="danger" @click.stop="fecharModalAtendimento()">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REQUISICAO ACOMPANHAMENTO
            ----------------------------------------------------------------------------------- -->

    <div>
      <b-modal ref="modal-requisicao-acompanhamento" 
          id="modal-requisicao-acompanhamento" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="ACOMPANHAMENTO DA REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ACOMPANHAMENTO DA REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="2">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="2">
                <b-form-fieldset label="Atendimento">
                  <b-form-input  type="date" 
                                v-model="requisicao.DATA_ATENDIMENTO"
                                :class="{'vazio': !requisicao.DATA_ATENDIMENTO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Requisitante">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Atendimento">
                  <b-form-input type="text" id="edUsuarioRequisitante" :disabled="true"  v-model="requisicao.USUARIO_ATENIMENTO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="2">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeRequisitante"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeCentroCusto"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeDepartamento"></b-form-input>
                </b-form-fieldset>
              </b-col>
            </b-row>
            
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhum Item"
                stacked="md"
                small
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalAtendimento.currentPage"
                :items="modalAtendimento.items" 
                :fields="modalAtendimento.fields">
                
                
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirOP_SALDO(item.item.STATUS_ATENDIMENTO)" >{{traduzirOP_SALDO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button    variant="danger" @click.stop="cancel">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>

    <!--  -----------------------------------------------------------------------------------
                                          MODAL TRILHA DE AUDITORIA
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-trilha" 
          id="modal-trilha" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="TRILHA DE AUDITORIA" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 TRILHA DE AUDITORIA
              </div>
            </div>
             <b-row class="mb-2">
                <b-col sm="2">
                  <b-form-fieldset label="Data Inicial">
                       <cec-input-data v-model="trilha.dt1" />
                  </b-form-fieldset>
                </b-col>  
                <b-col sm="2">
                  <b-form-fieldset label="Data Final">
                       <cec-input-data v-model="trilha.dt2" />
                  </b-form-fieldset>
                </b-col>  
                <b-col sm="5">
                  <b-form-fieldset label="Centro de Estoque">
                    <centro-estoque-almoxarifado-drop-down v-model="trilha.centroEstoqueId" label="Centro de Estoque" /> 
                   </b-form-fieldset>
                
                </b-col>  
                
                <b-col sm="1" class="d-flex mb-3 align-items-end">
                    <b-button 
                          type="button" 
                          variant="primary" 
                          @click.stop.prevent="listarTrilha()">
                        Listar
                      </b-button>
                </b-col>
                 <b-col sm="2" class="d-flex mb-3 align-items-end">
                   <b-button variant="success" @click.stop.prevent="abrirModalAjuste()">
                     <i class="fa fa-plus"></i> Novo Ajuste
                   </b-button>
                 </b-col>
              </b-row>
              <b-row>
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Lançamento "
                        stacked="md"
                        small
                        select-mode="single"
                        head-variant="dark"
                        bordered
                        :per-page="trilha.perPage"
                        :current-page="trilha.currentPage"
                        responsive
                        :items="trilha.items" 
                        :fields="trilha.fields">
                    <template #cell(OP_TIPO)="item">
                      <b-badge pill :variant="colorirOP_TIPO(item.item.OP_TIPO)">{{traduzirOP_TIPO(item.item.OP_TIPO)}}</b-badge>
                    </template>      
                    </b-table>
                    <b-row>
                      <b-col sm="2">
                        <b-form-select v-model="trilha.perPage" :options="trilha.pageOptions" size="sm"></b-form-select>
                      </b-col>
                      <b-col sm="10">
                        <b-pagination class="mb-0 bg-gray-100" :total-rows="trilha.items.length" :per-page="trilha.perPage" v-model="trilha.currentPage" />
                      </b-col>
                    </b-row>
                    
                </div>
              </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button    variant="danger" @click.stop="fecharModalTrilha()">
            FECHAR
          </b-button>
        </template>
        
      </b-modal>
    </div>

    <!--  -----------------------------------------------------------------------------------
                                          MODAL AJUSTE DE ESTOQUE
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-ajuste" 
          id="modal-ajuste" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="lg"
          headerClass= "p-2 border-bottom-0" 
          title="AJUSTE DE ESTOQUE" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 LANÇAMENTO AVULSO NO ESTOQUE DO ALMOXARIFADO - AJUSTE
              </div>
            </div>
            <b-row>
                <b-col sm="12">
                  <b-form-fieldset label="Centro de Estoque">
                    <centro-estoque-almoxarifado-drop-down v-model="modalAjuste.centroEstoqueId" label="Centro de Estoque" /> 
                   </b-form-fieldset>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4">
                    <b-form-fieldset label="Saldo Atual">
                         <vue-autonumeric  v-model="modalAjuste.saldoAtual" :options="formatoQuantidade" :disabled="true" class="form-control text-right"> </vue-autonumeric>
                    </b-form-fieldset>
                </b-col>
                <b-col sm="3">
                    <b-form-fieldset label="Data Movimento">
                       <cec-input-data v-model="modalAjuste.DATA_MOVIMENTO" />
                    </b-form-fieldset>
                </b-col>
                <b-col sm="3">
                    <b-form-fieldset label="Hora">
                       <b-form-timepicker v-model="modalAjuste.HORA_MOVIMENTO" locale="pt-BR" placeholder="00:00:00" />
                    </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                    <b-form-fieldset label="Quantidade">
                         <vue-autonumeric  v-model="modalAjuste.QUANT" :options="formatoQuantidade"  class="form-control text-right"> </vue-autonumeric>
                    </b-form-fieldset>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-fieldset label="Descrição / Observação">
                         <b-form-textarea
                            v-model="modalAjuste.observacao"
                            rows="3"
                          ></b-form-textarea>
                    </b-form-fieldset>
                </b-col>
            </b-row>

        </b-card>
         <template #modal-footer="{ cancel }">
          <b-button    variant="success" @click.stop="postAjuste()">
            SALVAR MOVIMENTO
          </b-button>
          <b-button    variant="danger" @click.stop="$refs['modal-ajuste'].hide()">
            CANCELAR
          </b-button>
        </template>
      </b-modal>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import cSwitch from '../../../components/Switch'
import Tools from '@/tools/tools.js'
import VueAutonumeric from 'vue-autonumeric'
import BensPesquisa from '../../pesquisa/BensPesquisa.vue'
import CentroCustoPesquisa from '../../pesquisa/CentroCustoPesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import { mapGetters } from 'vuex'

export default {
  components: { 
    SetFilter, 
    cSwitch,
    VueAutonumeric,
    BensPesquisa,
    CentroCustoPesquisa,
    CentroEstoquePesquisa,
    CentroEstoqueDropDown: () => import('@/views/componentes/dropdown/CentroEstoqueDropDown.vue'),
    CentroEstoqueAlmoxarifadoDropDown: () => import('@/views/componentes/dropdown/CentroEstoqueAlmoxarifadoDropDown.vue'),
    CecInputData,
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'dados',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'CODIGO', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Produto' },
      { key: 'QUANT', type: 'number', label: 'Saldo' },
      { key: 'NOME_GRUPO', type: 'string', label: 'Grupo' },
      { key: 'OP_SALDO',   type: 'string', label: 'Situação',
        labelMap: { 'N': 'Negativo', 'P': 'Positivo', 'Z': 'Zerado' } }
    ]
  })],

  data () {
    return {
      // NÃO precisa de stickyHeight aqui; o mixin já cuida ☑
      colunas: [
        { key: "CODIGO",      label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "DESCRICAO", label: 'Produto', sortable: true, class:'align-middle', thStyle: { width: "40%" }},
        { key: "ID_UNIDADE_COMERCIAL", label: 'Und', sortable: true, class:'align-middle text-right', thStyle: { width: "5%" }},
        { key: "NOME_GRUPO", label: 'Grupo', sortable: true, class:'align-middle', thStyle: { width: "25%" }},
        { key: "OP_SALDO", label: 'Situação', sortable: true, class:'align-middle text-center', thStyle: { width: "10%" }},
        { key: "QUANT", label: 'Saldo',  sortable: true, class:'text-right align-middle', thStyle: { width: "10%" } ,
            formatter: (value, key, item) =>  value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0 },
        { key: "actions", label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: "5%" }}
      ],
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      optionsREQUISITANTE_ID: [],
      optionsCENTRO_CUSTO_ID: [],
      optionsDEPARTAMENTO_ID: [],
      estoque:{
        produtoId: null,
        quant: 0,
        pecas: 0,
        maximumValue: 0

      },
      modalRequisicaoItem: {
        emAlteracao: false,
      },
      modalRequisicao: {
        emAlteracao: false,
        perPage: 20,
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "ID",
            headerName: 'Requisição',
            class:'align-middle text-right',
            thStyle: { width: "5%" },
            sortable: true
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "55%" },
            sortable: true 
          },
          {
            key: "OP_CONSUMIVEL",
            label: 'Cons', 
            class:'align-middle',
            thStyle: { width: "5%" },
            sortable: true 
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "15%" },
            sortable: true 
          },
          {
            key: "actions" ,
            class:'text-right', 
            thStyle: { width: "5%" },
            label: 'Ações' 
          }
        ],

      },
      requisicao: {
        ID                         : null,
        DATA_CADASTRO              : null,
        DATA_ALTERACAO             : null,
        DATA_EXCLUSAO              : null,
        USUARIO_CADASTRO           : null,
        USUARIO_ALTERACAO          : null,
        USUARIO_EXCLUSAO           : null,
        OBSERVACAO_REQUISICAO      : null,
        CENTRO_CUSTO_ID            : null,
        DEPARTAMENTO_ID            : null,
        CENTRO_ESTOQUE_ORIGEM_ID   : null,
        CENTRO_ESTOQUE_DESTINO_ID  : null,
        OP_STATUS                  : null,
        USUARIO_ATENIMENTO         : null,
        DATA_ATENDIMENTO           : null,
        USUARIO_REQUISICAO_ID      : null,
        OBSERVACAO_ATENDIMENTO     : null,
        USUARIO_ATENDIMENTO_ID     : null,
        USUARIO_ALTERACAO_ID       : null,
        DATA_NECESSIDADE           : null,
        REQUISITANTE_ID            : null,
      },
      item: {
        ID                 : null,
        ALMOXARIFADO_ID    : null,
        QUANT_REQUISITADO  : null,
        OBSERVACAO         : null,
        PRODUTO_ID         : null,
        VL_UNITARIO        : null,
        OP_CONSUMIVEL      : null,
        QUANT_UTILIZADO    : null,
        QUANT_ATENDIMENTO  : null,
        CENTRO_ESTOQUE_ID  : null,
      },
      modalAtendimento: {
        emAlteracao: false,
        perPage: 20,
        currentPage: 1,
        nomeRequisitante: null,
        nomeCentroCusto: null,
        nomeDepartamento: null,
        items: [],
        fields: [
          {
            key: "PRODUTO_ID",
            label: 'Id',
            class:'align-middle text-right',
            thStyle: { width: "5%" },
            sortable: true
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "35%" },
            sortable: true 
          },
          {
            key: "QUANT_ESTOQUE",
            label: 'Estoque',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_ATENDIMENTO",
            label: 'Atendido', 
            class:'align-middle',
            thStyle: { width: "20%" },
            sortable: true 
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Quantidade Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "10%" },
            sortable: true 
          }
        ],

      },
      modalTrilhaAberto: false,
      trilha: {
        currentPage: 1,
        perPage: 100,
        pageOptions: [10, 20, 50, 100],
        centroEstoqueId: null,
        dt1: Tools.getDataAtual(),
        dt2: Tools.getDataAtual(),
        items: [],
        fields: [
          {
            key: "DATA_MOVIMENTO",
            label: 'Movimento', 
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0',
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "MOVIMENTO",
            label: 'Rotina',
            class:'align-middle p-0',
            thStyle: { width: "20%" }
          },
          {
            key: "DESCRICAO",
            label: 'Descrição',
            class:'align-middle text-center p-0',
            thStyle: { width: "30%" }
          },
          {
            key: "USUARIO",
            label: 'Usuário',
            thStyle: { width: "10%" },
            class:'align-middle  p-0'
          },
          {
            key: "OP_TIPO",
            label: 'Tipo',
            thStyle: { width: "10%" }
          },
          {
            key: "QUANT",
            class:'text-right', 
            thStyle: { width: "80%" },
            label: 'Quantidade',
            formatter: (value, key, item) => 
              value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "SALDO",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Saldo',
            formatter: (value, key, item) => 
               value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          }
        ]
      },
      modalAjuste: {
        QUANT: 0,
        PECAS: 0,
        observacao: '',
        centroEstoqueId: null,
        saldoAtual: 0,
        DATA_MOVIMENTO: null,
        HORA_MOVIMENTO: null
      },
      
      statusOptions: [
        {text: 'CANCELADA', value: '0'},
        {text: 'REQUISITADA', value: '1'},
        {text: 'EM ATENDIMENTO', value: '2'},
        {text: 'ATENDIDA', value: '3'},
        {text: 'DEVOLVIDA', value: '4'},
        {text: 'ARQUIVADA', value: '5'}
      ],
      detalhes: {
        fields: [
          {
            key: "ID",
            label: 'Requisição',
            class:'align-middle text-right',
            thStyle: { width: "5%" }
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "55%" }
          },
          {
            key: "OP_CONSUMIVEL",
            label: 'Cons', 
            class:'align-middle',
            thStyle: { width: "5%" }
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "15%" }
          }
        ],

      },
    }
  },

  methods: {
    // Esses dois métodos garantem que eventos da CecPageBar
    // atualizem a store (e o mixin faz o resto).
    onPageChange (p) { this.currentPage = p },
    onPerPageChange (n) { this.perPage = n; this.currentPage = 1 },

    // INICIO DOS METODOS DE NEGOCIO
    async pesquisar () {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('almoxarifeEstoque/GET_LISTA')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalRequisacaoItem() {
      this.$refs.edItemPRODUTO_ID.$refs.auto.$refs.autocomplete.focus()
    },
    async toggleDetalhesListagem(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", row.item.ID)

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        const detalhes = await this.carregarDetalhesRequisicao(row.item.ID)

        this.$set(row.item, 'detalhes', detalhes)
        this.$set(row.item, 'loading', false)
      }

      row.toggleDetails()
    },
    abrirModalRequisicaoAdd () {
      // TODO: estoure seu modal real
      // this.$bvModal.show('id-do-seu-modal');
    },
    async rejeitarRequisicao() {
      this.$bvModal.msgBoxOk('Operação não permitida! Deixe vazio os itens e Encerre o Atendimento!', {
          title: 'Rejeitar',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
    },
    async deleteProduto() {
      this.$bvModal.msgBoxOk('Operação não permitida', {
          title: 'Remover',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      
    },
    async carregarUsuarios() {
      try {
        const {data}  = await this.$http.get('/api/protected/funcionario/listar')
        this.optionsREQUISITANTE_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsREQUISITANTE_ID.push({value: und.CODIGO, text: `${und.NOME} - ${und.CODIGO}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Requisitantes!')
        return
      }
    },
    async carregarCentroCusto() {
      try {
        const {data}  = await this.$http.get('/api/protected/centrocusto/listarTodos')
        this.optionsCENTRO_CUSTO_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsCENTRO_CUSTO_ID.push({value: und.CODIGO, text: `${und.DESCRICAO} - ${und.CODIGO}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Centros de Custo!')
        return
      }
    },
    async carregarDepartamento() {
      try {
        const {data}  = await this.$http.get('/api/protected/departamento/listarTodos')
        this.optionsDEPARTAMENTO_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsDEPARTAMENTO_ID.push({value: und.ID, text: `${und.NOME} - ${und.ID}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Departamentos!')
        return
      }
    },
    async carregarItensRequisicao() {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getByRequisicaoId/${this.requisicao.ID}`)
        this.modalRequisicao.items = data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarItensAtendimento() {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getItensAtendimento/${this.requisicao.ID}`)
        this.modalAtendimento.items = data.map(item => ({
          ...item,
          atendido: item.QUANT_ATENDIMENTO > 0
        }))
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarDetalhesRequisicao(id) {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getByRequisicaoId/${id}`)
        return data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarEstoqueDoProduto(id) {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getEstoqueByProdutoId/${id}`)
        this.estoque.quant = (data?.[0]?.QUANT) ?? 0.0
        this.estoque.pecas = (data?.[0]?.PECAS) ?? 0.0
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi verificar o estoque do Produto!')
        return
      }
    },
    async requisitarRequisicao() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.requisicao,
          login: window.localStorage.getItem('nomeusuario')
        }
        await this.$http.post('/api/protected/almoxarife/requisitar', requisicaoPayload )
        await this.pesquisar()
        this.$refs['modal-requisicao'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async abrirModalRequisicaoAdd() {
      this.requisicao.ID                         = null
      this.requisicao.DATA_CADASTRO = Tools.getDataAtual()
      this.requisicao.DATA_ALTERACAO             = null
      this.requisicao.DATA_EXCLUSAO              = null
      this.requisicao.USUARIO_CADASTRO           = window.localStorage.getItem('nomeusuario')
      this.requisicao.USUARIO_ALTERACAO          = null
      this.requisicao.USUARIO_EXCLUSAO           = null
      this.requisicao.OBSERVACAO_REQUISICAO      = null
      this.requisicao.CENTRO_CUSTO_ID            = null
      this.requisicao.DEPARTAMENTO_ID            = null
      this.requisicao.CENTRO_ESTOQUE_ORIGEM_ID   = null
      this.requisicao.CENTRO_ESTOQUE_DESTINO_ID  = null
      this.requisicao.OP_STATUS = '6' //Em cadastramento
      this.requisicao.USUARIO_ATENIMENTO         = null
      this.requisicao.DATA_ATENDIMENTO           = null
      this.requisicao.USUARIO_REQUISICAO_ID      = null
      this.requisicao.OBSERVACAO_ATENDIMENTO     = null
      this.requisicao.USUARIO_ATENDIMENTO_ID     = null
      this.requisicao.USUARIO_ALTERACAO_ID       = null
      this.requisicao.DATA_NECESSIDADE           = null
      this.requisicao.REQUISITANTE_ID            = null
      this.modalRequisicao.emAlteracao = false
      
      const loaders = [
        this.carregarUsuarios(),
        this.carregarCentroCusto(),
        this.carregarDepartamento()
      ]
      await Promise.all(loaders)

      this.modalRequisicao.items = []
      this.$refs['modal-requisicao'].show()

    },
    async selecionarRegistro(item) {
      this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", item.CODIGO)
    },
    async abrirModalItemRequisicaoAdd() {
      try {
        this.$store.commit('controle/setAguardando', true)

        //A requisicao ainda nao foi gravada no banco de dados
        if (!this.requisicao.ID) {
          const requisicaoPayload = {
            requisicao: this.requisicao,
            usuarioId:  window.localStorage.getItem('usuarioId')
          }
          const {data} = await this.$http.post('/api/protected/almoxarife/post', requisicaoPayload )
          this.requisicao = {...data.requisicao ?? null}
          this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
          this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)

          this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", this.requisicao.ID)
        }  

        this.item.ID                 = null,
        this.item.ALMOXARIFADO_ID    = this.requisicao.ID
        this.item.QUANT_REQUISITADO  = 0.00
        this.item.OBSERVACAO         = null
        this.item.PRODUTO_ID         = null
        this.item.VL_UNITARIO        = null
        this.item.OP_CONSUMIVEL      = null
        this.item.QUANT_UTILIZADO    = null
        this.item.QUANT_ATENDIMENTO  = null
        this.item.CENTRO_ESTOQUE_ID  = null
        //this.item.CENTRO_ESTOQUE_ID =  qrParametrosCENTRO_ESTOQUE_ALMOXARIFADO_ID.asInteger;
        this.modalRequisicaoItem.emAlteracao = false
        this.$refs['modal-requisicao-item'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalItemRequisicaoEdit(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/item/getById/${item.ID}`)
        this.item = {...data?.[0]} ?? {}
        this.modalRequisicaoItem.emAlteracao = true
        this.$refs['modal-requisicao-item'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async postItemRequisicao() {
      if (this.item.QUANT_REQUISITADO <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Quantidade'  )
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.item
        }
        await this.$http.post('/api/protected/almoxarife/item/post', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteItemRequisicao(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Remover o ${item.NOME_PRODUTO} da Requisição?`, {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          id: item.ID,
          requisicaoId: item.ALMOXARIFADO_ID,
          login: window.localStorage.getItem('nomeusuario')
        }
        await this.$http.post('/api/protected/almoxarife/item/delete', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItemRequisicao() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.item
        }
        await this.$http.post('/api/protected/almoxarife/item/edit', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalAtendimento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.USUARIO_ATENDIMENTO_ID = window.localStorage.getItem('usuarioId')
        this.requisicao.USUARIO_ATENIMENTO = window.localStorage.getItem('nomeusuario')

        
        
        const loaders = [
          this.carregarUsuarios(),
          this.carregarCentroCusto(),
          this.carregarDepartamento(),
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

        this.modalAtendimento.nomeCentroCusto =  this.optionsCENTRO_CUSTO_ID.find(el => el.value === this.requisicao.CENTRO_CUSTO_ID)?.text || null;
        this.modalAtendimento.nomeRequisitante =  this.optionsREQUISITANTE_ID.find(el => el.value === this.requisicao.REQUISITANTE_ID)?.text || null;
        this.modalAtendimento.nomeDepartamento =  this.optionsDEPARTAMENTO_ID.find(el => el.value === this.requisicao.DEPARTAMENTO_ID)?.text || null;

        this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.$refs['modal-atendimento'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async fecharModalAtendimento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.pesquisar()
        this.$refs['modal-atendimento'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async fecharModalRequisicao() {
      if (!this.requisicao.ID) {
        this.$refs['modal-requisicao'].hide()
        return 
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.pesquisar()
        this.$refs['modal-requisicao'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalAcompanhamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        this.requisicao.USUARIO_ATENDIMENTO_ID = window.localStorage.getItem('usuarioId')
        this.requisicao.USUARIO_ATENIMENTO = window.localStorage.getItem('nomeusuario')

        
        
        const loaders = [
          this.carregarUsuarios(),
          this.carregarCentroCusto(),
          this.carregarDepartamento(),
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

        this.modalAtendimento.nomeCentroCusto =  this.optionsCENTRO_CUSTO_ID.find(el => el.value === this.requisicao.CENTRO_CUSTO_ID)?.text || null;
        this.modalAtendimento.nomeRequisitante =  this.optionsREQUISITANTE_ID.find(el => el.value === this.requisicao.REQUISITANTE_ID)?.text || null;
        this.modalAtendimento.nomeDepartamento =  this.optionsDEPARTAMENTO_ID.find(el => el.value === this.requisicao.DEPARTAMENTO_ID)?.text || null;

        this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.$refs['modal-requisicao-acompanhamento'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },

    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['almoxarifeEstoque/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    traduzirOP_SALDO(valor) {
      let opcao = valor ? valor.trim() : ''
      switch (opcao) {
        case 'N':
          return 'Negativo'
        case 'P':
          return 'Positivo'
        case 'Z':
          return 'Zerado'
        default:
          return ''
      }
    },
    colorirOP_SALDO(valor) {
      let opcao = valor ? valor.trim() : ''
      switch (opcao) {
        case 'N':
          return 'danger'
        case 'P':
          return 'success'
        case 'Z':
          return 'secondary'
        default:
          return ''
      }
    },
    traduzOP_STATUS(valor) {
      switch (valor) {
        case 'N':
          return 'Negativo'
        case 'P':
          return 'Positivo'
        case 'Z':
          return 'Zerado'
        default:
          return ''
      }
    },
    colorirOP_STATUS(valor) {
      switch (valor) {
        case '0':
          return 'danger'
        case '1':
          return 'info'
        case '2':
          return 'primary'
        case '3':
          return 'success'
        case '4':
          return 'gray-200'
        case '5':
          return 'secondary'  
        case '6':
          return 'warning'    
        default:
          return ''
      }
    },
    colorirOP_STATUS_MODAL(valor) {
      switch (valor) {
        case '0':
          return 'text-danger'
        case '1':
          return 'text-info'
        case '2':
          return 'text-primary'
        case '3':
          return 'text-success'
        case '4':
          return 'text-gray-200'
        case '5':
          return 'text-secondary'  
        case '6':
          return 'text-warning'    
        default:
          return ''
      }
    },

    limparFiltro() {
      this.$store.commit("almoxarifeEstoque/SET_LIMPAR", null);
    },
    async postQuantAtendimento(item){
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadItem = {
          requisicaoId: this.requisicao.ID,
          id: item.ID,
          produtoId: item.PRODUTO_ID,
          quant: item.QUANT_ATENDIMENTO,
          login: window.localStorage.getItem('nomeusuario')
        }

        await this.$http.post(`/api/protected/almoxarife/item/editAtendimento`, payloadItem)
        

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ALMOXARIFADO_ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        const loaders = [
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteQuantAtendimento(item){
      const msg = await this.$bvModal.msgBoxConfirm(`Remover o ${item.NOME_PRODUTO} atendimento?`, {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadItem = {
          requisicaoId: this.requisicao.ID,
          id: item.ID,
          produtoId: item.PRODUTO_ID,
          quant: 0,
          login: window.localStorage.getItem('nomeusuario')
        }

        await this.$http.post(`/api/protected/almoxarife/item/editAtendimento`, payloadItem)
        

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ALMOXARIFADO_ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        const loaders = [
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async finalizarAtendimento() {
      let naoAtendidos = this.modalAtendimento.items.length 
        ? this.modalAtendimento.items.every(item => item.QUANT_RESTANTE > 0 ) 
        : true

      const mensagem = (naoAtendidos == true)
        ? `Existem itens não atendido, ou incompletos!!! Finalizar o atendimento?`
        : `Finalizar o atendimento?`
        
      const msg = await this.$bvModal.msgBoxConfirm(mensagem, {
        title: 'Finalizar',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return
      
      try {
        const finalizarPayload = {
          requisicao: this.requisicao,
          login: window.localStorage.getItem('nomeusuario')
        }
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/almoxarife/finalizar', finalizarPayload )
        await this.pesquisar()
        this.$refs['modal-atendimento'].hide()

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    permiteDeleteQuantAtendimento(item) {
      return item.atendido == true
    },
    permitePostQuantAtendimento(item) {
      return item.atendido == false
    },
    
    handleKeydown(event) {
    },
    async imprimirPorProduto () {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          const relPayLoad = {
            usuario: window.localStorage.getItem('nomeusuario'),
            positivos: this.positivos
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/almoxarife/porproduto`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relEstoqueAlmoxarifado.pdf') 
          link.download = 'relEstoqueAlmoxarifado.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = item.ID +' Estoque do Almoxarifado por Produto'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async imprimirPorGrupo () {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          const relPayLoad = {
            usuario: window.localStorage.getItem('nomeusuario'),
            positivos: this.positivos
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/almoxarife/porgrupo`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relEstoqueAlmoxarifadoPorGrupo.pdf') 
          link.download = 'relEstoqueAlmoxarifadoPorGrupo.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = item.ID +' Estoque do Almoxarifado por Grupo'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async listarTrilha() {
      if (!this.trilha.centroEstoqueId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Centro de Estoque!')
        return
      }
      if (!this.trilha.dt1 || !this.trilha.dt2) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Período!')
        return
      }
      const item = this.$store.getters['almoxarifeEstoque/LISTA'].find(x => x.CODIGO == this.$store.getters['almoxarifeEstoque/REGISTRO_SELECIONADO_ID'])
      
      const payloadTrilha = {
        dt1: this.trilha.dt1,
        dt2: this.trilha.dt2,
        centroEstoqueId: this.trilha.centroEstoqueId,
        produtoId: item.CODIGO
      }  
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const {data} = await this.$http.post(`/api/protected/estoque/listarTrilhaAlmoxarifado`, payloadTrilha)
        this.trilha.items = data

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar a trilha do produto!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirModalTrilha(item) {
        this.$store.commit("almoxarifeEstoque/SET_REGISTRO_SELECIONADO_ID", item.CODIGO);
        this.trilha.items = []; 
        this.$refs['modal-trilha'].show();
        this.modalTrilhaAberto = true;
    },
    fecharModalTrilha() {
        this.$refs['modal-trilha'].hide();
        this.modalTrilhaAberto = false;
    },
    colorirOP_TIPO(valor) {
      switch (valor) {
        case 'E': return 'success';
        case 'S': return 'danger';
        case 'A': return 'warning';
        case 'I': return 'info';
        default: return 'secondary';
      }
    },
    traduzirOP_TIPO(valor) {
      switch (valor) {
        case 'E': return 'Entrada';
        case 'S': return 'Saída';
        case 'A': return 'Ajuste';
        case 'I': return 'Inventário';
        default: return valor;
      }
    },
    abrirModalAjuste() {
         const item = this.$store.getters['almoxarifeEstoque/LISTA'].find(x => x.CODIGO == this.$store.getters['almoxarifeEstoque/REGISTRO_SELECIONADO_ID']);
         this.modalAjuste.QUANT = 0;
         this.modalAjuste.PECAS = 0;
         this.modalAjuste.observacao = '';
         this.modalAjuste.centroEstoqueId = null;
         this.modalAjuste.saldoAtual = item ? item.QUANT : 0;
         this.modalAjuste.DATA_MOVIMENTO = moment().format('YYYY-MM-DD');
         this.modalAjuste.HORA_MOVIMENTO = moment().format('HH:mm:ss');
         this.$refs['modal-ajuste'].show();
    },
    async postAjuste() {
        const item = this.$store.getters['almoxarifeEstoque/LISTA'].find(x => x.CODIGO == this.$store.getters['almoxarifeEstoque/REGISTRO_SELECIONADO_ID']);
        if (!item) return;

        if (!this.modalAjuste.centroEstoqueId) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Centro de Estoque!');
            return;
        }

        try {
            this.$store.commit('controle/setAguardando', true);
            const payload = {
                USUARIO: window.localStorage.getItem('login') || 'USUARIO', 
                OP_TIPO: 'A',
                QUANT: this.modalAjuste.QUANT,
                PECAS: this.modalAjuste.PECAS,
                DATA_MOVIMENTO: this.modalAjuste.DATA_MOVIMENTO && this.modalAjuste.HORA_MOVIMENTO ? `${this.modalAjuste.DATA_MOVIMENTO} ${this.modalAjuste.HORA_MOVIMENTO}` : moment().format('YYYY-MM-DD HH:mm:ss'),
                PRODUTO_ID: item.CODIGO,
                CENTRO_ESTOQUE_ID: this.modalAjuste.centroEstoqueId,
                DESCRICAO: this.modalAjuste.observacao
            };

            await this.$http.post('/api/protected/almoxarife/estoque/post', payload);
            
            Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Ajuste realizado com sucesso!');
            this.$refs['modal-ajuste'].hide();
            this.listarTrilha(); 

        } catch (err) {
            console.error(err);
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao realizar ajuste.');
        } finally {
            this.$store.commit('controle/setAguardando', false);
        }
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Estoque Almoxarifado',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'estoque_almoxarifado.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'estoque_almoxarifado.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions'),
        filename: 'estoque_almoxarifado.csv',
      });
    },
  },
  computed: {
    ...mapGetters('tema',{isDark: 'IS_DARK'}),

    currentPage: {
      get () {
        return this.$store.getters['almoxarifeEstoque/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("almoxarifeEstoque/SET_PAGINA_ATUAL", Number(value) || 1);
      }
    },
    positivos: {
      get () {
        const v = this.$store.getters['almoxarifeEstoque/POSITIVOS'];
        return (v === undefined || v === null) ? true : v; // default só se indefinido/nulo
      },
      set (v) {
        this.$store.commit('almoxarifeEstoque/SET_POSITIVOS', v)
      }
    },
    perPage: {
      get () {
        return this.$store.getters['almoxarifeEstoque/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('almoxarifeEstoque/SET_PER_PAGE', Number(v) || 25)
      }
    },
    
    dados: {
      get () {
        return this.$store.getters['almoxarifeEstoque/LISTA']
      }, 
      set (value) {
        this.$store.commit("almoxarifeEstoque/SET_LISTA", value);
      }
    },
    habilitaBotaoRejeitar() {
    // retorna true somente se TODOS os itens tiverem QUANT_ATENDIMENTO = 0
      return this.modalAtendimento.items.length 
        ? this.modalAtendimento.items.every(item => item.QUANT_ATENDIMENTO === 0) 
        : false
    }
  },
  watch: {
    positivos(newVal, oldVal) {
      if (newVal != oldVal) {
        this.pesquisar()
      }
    }
  },
  async created() {
    await this.pesquisar()
  }
}
</script>
<style >
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky */
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #1f3b63 !important;
  color: #fff !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #fff !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #1f3b63 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #214674 !important;
}


</style>



// WEBPACK FOOTER //
// src/views/almoxarifado/estoque/EstoqueAlmoxarifadoListagem.vue